import type { RectangleShapeAttributes } from '../utils/shapeAttributes';

export function drawSelectionBorder(
  context: CanvasRenderingContext2D,
  attributes: RectangleShapeAttributes,
  zoom: number
) {
  const borderWidth = Math.max(1, Math.floor(2 / zoom));

  context.setLineDash([0]);
  context.beginPath();
  context.rect(
    attributes.x - attributes.lineThickness / 2 - borderWidth / 2,
    attributes.y - attributes.lineThickness / 2 - borderWidth / 2,
    attributes.width + attributes.lineThickness + borderWidth,
    attributes.height + attributes.lineThickness + borderWidth
  );
  context.lineWidth = borderWidth;
  context.strokeStyle = '#7dc9fb';
  context.stroke();
}
